import { render, staticRenderFns } from "./AddNewMyQulificationPopUp.vue?vue&type=template&id=b8b6da2c&scoped=true&"
import script from "./AddNewMyQulificationPopUp.vue?vue&type=script&lang=js&"
export * from "./AddNewMyQulificationPopUp.vue?vue&type=script&lang=js&"
import style0 from "./AddNewMyQulificationPopUp.vue?vue&type=style&index=0&id=b8b6da2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b6da2c",
  null
  
)

export default component.exports